<template>
	<div>
		<v-subheader class="font-weight-bold pa-0">
			{{ $t("label.address") }}
			<v-chip color="black" class="ml-5" dark x-small outlined>
				{{ order.address.name }}
			</v-chip>
		</v-subheader>
		<p>
			{{ order.address.house_number }}, {{ order.address.street }},
			{{ order.address.address }}
		</p>
	</div>
</template>

<script>
export default {
	props: ["order"],
};
</script>